// Modules
import React from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import browserHistory from 'react-router/lib/browserHistory';
import connect from 'react-redux/lib/connect/connect';
import PropTypes from 'prop-types';
import { getLang } from 'redux-pagan';
import {
  openAuthenticationModal,
  switchAuthModalType
} from '../../redux/modules/userAuthentication';
import { setAnalyticsProviderData } from '../../utils/analytics/analyticsManager';
import { isTemporaryEmail } from '../../utils/checkers';
import checkRtlLanguage from '../../utils/checkRtlLanguage';
import { authenticationModalType, storage } from '../../constants';
import MouseFlowService from '../../services/MouseFlowService';
import appendLocale from '../../helpers/appendLocale';
import ModalError from './ModalError/ModalError';
import AuthTabList from './AuthTabList/AuthTabList';
import * as styles from './AuthenticationContainer.scss';

class AuthenticationContainer extends React.Component {
  state = {
    isFailModalOpen: get(this.props, 'userAuthentication.error')
  }

  componentDidMount() {
    const { locale } = this.props;
    if (!!this.props.userToken) {
      this.redirectToUserProfile(locale);
    }
  }

  componentWillReceiveProps(newProps) {
    const { userAuthentication: userData, isRedirectEnabled = false } = newProps;
    const { userIsAuthorized, error } = this.props.userAuthentication;
    if (userData.error && userData.error !== error) {
      this.openFailModal();
    }

    // Triggers after successful auth
    if (userData && userData.userIsAuthorized && userData.userIsAuthorized !== userIsAuthorized) {
      if (isRedirectEnabled) {
        this.redirectToUserProfile(this.props.locale);
      }

      if (userData.data) {
        this.sendAnalyticsInfo(userData);
      }

      if (isTemporaryEmail(userData.data.email)) {
        this.props.openAuthenticationModal({ bodyType: authenticationModalType.UPDATE_TEMPORARY_PROFILE }).then(() => {
          MouseFlowService.initialize().then(() => {
            MouseFlowService.startRecording();
            MouseFlowService.tagRecord(authenticationModalType.UPDATE_TEMPORARY_PROFILE);
          });
        });
      }
    }
  }

  sendAnalyticsInfo = (userData) => {
    storage.value.setItem('userData', JSON.stringify(userData.data));
    setAnalyticsProviderData({ userId: userData.data.id });
    setAnalyticsProviderData({
      dimension1: userData.data.is_agent ? 'realtor' : 'regular'
    });
  }

  redirectToUserProfile = (locale) => {
    browserHistory.push(appendLocale(locale, '/profile/edit'));
  }

  closeFailModal = () => this.setState({ isFailModalOpen: false });
  openFailModal = () => this.setState({ isFailModalOpen: true });

  render() {
    const { translate, activeTab, onTabClick, title, className } = this.props;

    return (
      <div className={cx(styles.container, className)}>
        <div className={cx('auth-container-modal-content', styles.content)}>
          {title && <p className={styles.title}>{title}</p>}
          <div className={styles.tabsWrapper}>
            <AuthTabList
              translate={translate}
              onTabClick={onTabClick}
              activeTab={activeTab}
            />
          </div>
        </div>
        <ModalError
          isRtl={this.props.isRtl}
          isOpen={this.state.isFailModalOpen}
          translate={translate}
          error={this.props.userAuthentication.error}
          onRequestClose={this.closeFailModal}
        />
      </div>
    );
  }
}

AuthenticationContainer.propTypes = {
  translate: PropTypes.func,
  openAuthenticationModal: PropTypes.func,
  locale: PropTypes.string,
  isRtl: PropTypes.bool,
  userToken: PropTypes.string,
  authenticationModalType: PropTypes.string,
  userAuthentication: PropTypes.object,
  switchAuthModalType: PropTypes.func,
  onTabClick: PropTypes.func,
  activeTab: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  isRedirectEnabled: PropTypes.bool
};

const mapDispatchToProps = {
  openAuthenticationModal,
  switchAuthModalType
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static'),
  isRtl: checkRtlLanguage(state.lang.locale),
  userAuthentication: state.userAuthentication,
  authenticationModalType: state.userAuthentication.authenticationModalType,
  userToken: get(state.userAuthentication, 'data.access_token'),
  locale: state.lang.locale
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationContainer);
